module.exports = __webpack_public_path__ + "static/avasta-40a1087ec0a920895d04f7791f692e5e.ttf";